import React, {useEffect, useState} from "react";
import {FaFileUpload, FaUserAlt} from "react-icons/fa";
import {IoCheckmarkDoneOutline} from "react-icons/io5";
import {IoMdCheckmark} from "react-icons/io";
import {AiOutlineSend} from "react-icons/ai";
import {PhotoIcon} from "@heroicons/react/24/solid";
import {getList} from "../services/service";
import {useSelector} from "react-redux/es/exports";
import Modal from "../components/modal/modal";

const Feedback = () => {
    const {token} = useSelector((state) => state.user);
    const [users, setUsers] = useState([]);
    const [chatData, setChatData] = useState([]);
    const [inputMessage, setInputMessage] = useState("");
    const [caption, setCaption] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [chatId, setChatId] = useState(null);
    const [selectedImage, setSelectedImage] = useState({
        preview: "",
        data: "",
    });
    const getUsersData = async () => {
        try {
            const response = await getList(
                `${process.env.REACT_APP_HOST_BASE_URL}/v1/feedback/list`,
                token
            );
            console.log(response)
            if (response.success !== true) {
                throw Error(`Something went wrong`);
            } else {
                setUsers(response.data);
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    const getChatData = async (userId) => {
        try {
            const response = await getList(
                `${process.env.REACT_APP_HOST_BASE_URL}/v1/feedback/list/${userId}`,
                token
            );
            if (response.success !== true) {
                throw Error(`Something went wrong`);
            } else {
                console.log(response, "res");
                setChatData(response.data);
                setChatId(response.data[0]?.chatId);
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    useEffect(() => {
        getUsersData();
    }, []);

    const userTabHandler = (userId) => {
        getChatData(userId);
        setSelectedUserId(userId);
    };
    const handleClose = () => {
        setOpenModal(false);
    };
    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            setLoading(true);
            const formdata = new FormData();
            formdata.append("file", selectedImage.data);
            const blob = new Blob(
                [
                    JSON.stringify({
                        content: caption ? caption.trim() : inputMessage.trim(),
                        userId: 10,
                        chatId: chatId,
                    }),
                ],
                {
                    type: "application/json",
                }
            );
            formdata.append("data", blob);
            const response = await fetch(
                `${process.env.REACT_APP_HOST_BASE_URL}/v1/feedback/send`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    body: formdata,
                }
            );
            if (response.ok !== true) {
                throw Error(`Something went wrong`);
            } else {
                getChatData(selectedUserId);
                if (caption || selectedImage.data) {
                    setCaption("");
                    setSelectedImage({
                        preview: "",
                        data: "",
                    });
                    setOpenModal(false);
                } else {
                    setInputMessage("");
                }
            }
        } catch (error) {
            console.log(error.message);
        } finally {
            setLoading(false);
        }
    };

    const fileChangeHandler = (e) => {
        setSelectedImage((prevState) => {
            return {
                ...prevState,
                preview: e.target.files[0]
                    ? URL.createObjectURL(e.target.files[0])
                    : "",
                data: e.target.files[0],
            };
        });
    };

    return (
        <>
            <Modal open={openModal} handleClose={handleClose}>
                <div>
                    <form onSubmit={handleSubmit} className={"space-y-4"}>
                        <h1 className={"text-gray-900 font-medium"}>Send an image</h1>
                        <div>
                            <div className="">
                                <label
                                    htmlFor="cover-photo"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    Cover photo
                                </label>
                                <div
                                    className="flex justify-center px-6 py-10 mt-2 border border-dashed rounded-lg border-gray-900/25">
                                    <div className="text-center">
                                        {selectedImage.data ? (
                                            <img
                                                src={selectedImage?.preview}
                                                className={"rounded-md max-h-28 mx-auto"}
                                                alt={"There is image which you selected"}
                                            />
                                        ) : (
                                            <PhotoIcon
                                                className="w-12 h-12 mx-auto text-gray-300"
                                                aria-hidden="true"
                                            />
                                        )}
                                        <div className="flex justify-center mt-4 text-sm leading-6 text-gray-600">
                                            <label
                                                htmlFor="file-upload"
                                                className="relative font-semibold text-indigo-600 bg-white rounded-md cursor-pointer focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                                            >
                                                <span className="m-0">Upload a file</span>
                                                <input
                                                    onChange={fileChangeHandler}
                                                    id="file-upload"
                                                    name="file-upload"
                                                    type="file"
                                                    className="sr-only"
                                                />
                                            </label>
                                            <p className="pl-1 m-0">or drag and drop</p>
                                        </div>
                                        <p className="text-xs leading-5 text-gray-600">
                                            PNG, JPG, GIF up to 10MB
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"space-y-4"}>
                            <div>
                                <label
                                    htmlFor="caption"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    Caption
                                </label>
                                <div className="mt-2">
                  <textarea
                      rows={4}
                      disabled={selectedImage?.data ? false : true}
                      name="caption"
                      id="caption"
                      className="block resize-none w-full bg-neutral-100 focus:bg-white rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      onChange={(e) => setCaption(e.target.value)}
                      value={caption}
                  />
                                </div>
                            </div>
                            <div className={"flex justify-end space-x-4"}>
                                <button
                                    className={
                                        "border border-indigo-600 text-indigo-600 px-4 py-1 rounded-md hover:bg-indigo-600 hover:border-transparent hover:text-white ease-in-out duration-200"
                                    }
                                    type={"button"}
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    className={
                                        "border border-indigo-600 text-indigo-600 px-4 py-1 rounded-md hover:bg-indigo-600 hover:border-transparent hover:text-white ease-in-out duration-200"
                                    }
                                    type={"submit"}
                                    disabled={selectedImage?.data ? false : true}
                                >
                                    Send
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>
            <div className={"grid grid-cols-12 gap-6 px-4 py-4 sm:px-6 lg:px-6 "}>
                <nav
                    className=" h-[565px] overflow-auto col-span-4 overflow-y-auto"
                    aria-label="Directory"
                >
                    <div className="relative">
                        <div className="divide-y divide-gray-300">
                            {users.map((person) => (
                                <button
                                    type={"button"}
                                    key={person.id}
                                    onClick={() => userTabHandler(person.userId)}
                                    className={`${
                                        person?.userId === selectedUserId
                                            ? "bg-cyan-500  text-white"
                                            : "bg-white text-cyan-500 hover:bg-neutral-100"
                                    } flex  items-center  w-full px-2 py-2 cursor-pointer  gap-x-4`}
                                >
                  <span>
                    <FaUserAlt className={"w-7 h-7 "}/>
                  </span>
                                    <div className="flex items-center justify-between flex-grow">
                                        <p className="mb-0 text-sm font-semibold leading-6 ">
                                            {person?.userName}
                                        </p>
                                        <span
                                            className={`${
                                                person?.userId === selectedUserId
                                                    ? "bg-white text-cyan-500"
                                                    : "bg-cyan-500 text-white"
                                            }  px-2 text-sm rounded-full`}
                                        >
                      {person?.notification}
                    </span>
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>
                </nav>
                <div className={"col-span-8 h-[500px]"}>
                    {selectedUserId ? (
                        <div
                            className={
                                "flex  items-end border border-neutral-200 p-4 rounded-xl "
                            }
                        >
                            <div className={"w-full"}>
                                <div
                                    className={
                                        "max-h-[450px] overflow-auto overflow-x-hidden py-4"
                                    }
                                >
                                    <div className={"space-y-4"}>
                                        {chatData.length > 0 &&
                                            chatData.map((item) => (
                                                <div key={item.id}>
                                                    {item.userId === 10 && item.imgId ? (
                                                        <div className={"flex justify-end"}>
                                                            <div
                                                                className={
                                                                    "bg-indigo-600 max-w-[400px] rounded-l-xl rounded-tr-xl text-white"
                                                                }
                                                            >
                                                                <img
                                                                    className={" rounded-tl-xl rounded-tr-xl"}
                                                                    src={`${process.env.REACT_APP_HOST_BASE_URL}/v1/file/message/img/${item?.imgId}`}
                                                                    alt={item.content}
                                                                />
                                                                <div
                                                                    className={"p-2 flex flex-col justify-end"}
                                                                >
                                  <span
                                      className={
                                          "text-sm md:text-base text-justify"
                                      }
                                  >
                                    {item?.content}
                                  </span>
                                                                    <span
                                                                        className={
                                                                            "  ml-3  text-sm flex items-center justify-end text-white "
                                                                        }
                                                                    >
                                    {item?.sendDate}{" "}
                                                                        {item.isChecked ? (
                                                                            <IoCheckmarkDoneOutline
                                                                                className={" ml-2 w-5 h-5 "}
                                                                            />
                                                                        ) : (
                                                                            <IoMdCheckmark
                                                                                className={" ml-2 w-5 h-5 "}
                                                                            />
                                                                        )}
                                  </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : item.userId === 10 ? (
                                                        <div className={"flex justify-end relative"}>
                                                            <div
                                                                className={
                                                                    "bg-indigo-600 max-w-[300px] md:max-w-xl flex flex-col justify-end text-white  py-2 pl-4 pr-4 rounded-t-xl rounded-l-xl"
                                                                }
                                                            >
                                <span
                                    className={
                                        "text-sm md:text-base text-justify"
                                    }
                                >
                                  {item?.content}
                                </span>
                                                                <span
                                                                    className={
                                                                        " ml-3 text-sm flex items-center justify-end text-white "
                                                                    }
                                                                >
                                  {item?.sendDate}{" "}
                                                                    {item.isChecked ? (
                                                                        <IoCheckmarkDoneOutline
                                                                            className={" ml-2 w-5 h-5 "}
                                                                        />
                                                                    ) : (
                                                                        <IoMdCheckmark
                                                                            className={" ml-2 w-5 h-5 "}
                                                                        />
                                                                    )}
                                </span>
                                                            </div>
                                                        </div>
                                                    ) : item.imgId ? (
                                                        <div
                                                            className={
                                                                "flex flex-col items-start justify-start"
                                                            }
                                                        >
                              <span
                                  className={
                                      "text-sm mb-2 text-white px-2 rounded-full bg-red-700 inline"
                                  }
                              >
                                {item?.sender}
                              </span>
                                                            <div
                                                                className={
                                                                    "bg-amber-200 max-w-[400px] rounded-bl-xl rounded-r-xl text-gray-800"
                                                                }
                                                            >
                                                                <img
                                                                    className={" rounded-tr-xl"}
                                                                    src={`http://192.168.7.91:9091/v1/file/message/img/${item?.imgId}`}
                                                                    alt={item.content}
                                                                />
                                                                <div
                                                                    className={"p-2 flex flex-col justify-end"}
                                                                >
                                  <span
                                      className={
                                          "text-sm md:text-base text-gray-800 text-justify"
                                      }
                                  >
                                    {item?.content}
                                  </span>
                                                                    <span
                                                                        className={
                                                                            "ml-3 text-sm flex items-center justify-end "
                                                                        }
                                                                    >
                                    {item?.sendDate}
                                  </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className={
                                                                "flex max-w-[300px] md:max-w-xl items-start flex-col justify-start"
                                                            }
                                                        >
                              <span
                                  className={
                                      "text-sm mb-2 text-white px-2 rounded-full bg-red-700 inline"
                                  }
                              >
                                {item?.sender}
                              </span>
                                                            <div
                                                                className={
                                                                    "flex py-2 px-4 bg-amber-200 rounded-bl-xl rounded-r-xl flex-col justify-end"
                                                                }
                                                            >
                                <span
                                    className={
                                        " inline-block text-sm md:text-base text-justify "
                                    }
                                >
                                  {item.content}
                                </span>
                                                                <span
                                                                    className={
                                                                        " inline-block  ml-3  text-sm flex items-center justify-end text-gray-800 "
                                                                    }
                                                                >
                                  {item?.sendDate}
                                </span>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                    </div>
                                </div>
                                <div className={"mt-4 "}>
                                    <form onSubmit={handleSubmit} className={"relative"}>
                    <textarea
                        className={
                            "block resize-none w-full bg-neutral-100 focus:bg-white rounded-md border-0 py-2 md:py-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        }
                        rows={1}
                        required
                        placeholder={"Write a message..."}
                        value={inputMessage}
                        onChange={(e) => setInputMessage(e.target.value)}
                    />
                                        <div className={"flex absolute right-0 top-0 justify-end"}>
                                            <button
                                                type="button"
                                                onClick={() => setOpenModal(true)}
                                                className="p-2 text-white bg-indigo-600 border-r border-white shadow-sm md:p-3 hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                            >
                                                <FaFileUpload className={" w-5 h-5 md:w-6 md:h-6"}/>
                                            </button>
                                            <button
                                                type="submit"
                                                className="p-2 text-white bg-indigo-600 shadow-sm rounded-r-md md:p-3 hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                            >
                                                <AiOutlineSend
                                                    className={"ml-1 w-5 h-5 md:w-6 md:h-6"}
                                                />
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div
                            className={
                                "flex justify-center items-center h-full border border-dashed border-cyan-500 rounded-md bg-cyan-50"
                            }
                        >
                            <p className={"text-white bg-cyan-500 px-4 rounded-full"}>
                                Select a chat to start messaging
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Feedback;
